import { rms, SR, SILENCE_RMS } from "./audio";

let n = 0;
export const uid = () => `c${Date.now().toString(36)}${(n++).toString(36)}${Math.random().toString(36).slice(2, 6)}`;

const HALLUCINATIONS = [
  /^(thanks?( you)? (so much )?for watching[.!]*)$/i,
  /^(please )?(like (and|&) )?subscribe[.!]*$/i,
  /subtitles? (by|created)|amara\.org|transcribed by|www\.\S+\.(com|org)/i,
  /^[[(]?(music|applause|laughter|silence|noise|संगीत)[\])]?$/i,
  /^[\s.,!?♪♫-]*$/,
];

const B = "(^|[\\s.,!?;:\"'()।])";
const E = "(?=$|[\\s.,!?;:\"'()।])";
const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function parseWordList(text) {
  return (text || "")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((l) => {
      const [from, to] = l.split(/\s*(?:=>|->|=)\s*/);
      return to ? { from: from.trim(), to: to.trim() } : { from: from.trim(), to: from.trim() };
    })
    .filter((w) => w.from);
}

export function applyWordList(text, list) {
  let t = text;
  for (const { from, to } of list) t = t.replace(new RegExp(B + esc(from) + E, "gi"), (m, p) => p + to);
  return t;
}

export function tidy(text) {
  let t = text.replace(/\s+/g, " ").trim();
  t = t.replace(/\s+([,.!?;:।])/g, "$1").replace(/([,!?;:])(?=[^\s\d"'),.])/g, "$1 ");
  let collapsed = false;
  t = t.replace(/(^|\s)(\S+)((?:\s+\2){3,})/gi, (m, p, w) => { collapsed = true; return `${p}${w} ${w}`; });
  if (/^[a-z]/.test(t)) t = t[0].toUpperCase() + t.slice(1);
  return { text: t, collapsed };
}

export function postprocess(raw, audio, wordListText) {
  const list = parseWordList(wordListText);
  const out = [];
  for (const seg of raw.sort((a, b) => a.start - b.start)) {
    const { text, collapsed } = tidy(applyWordList(seg.text, list));
    if (!text || HALLUCINATIONS.some((r) => r.test(text))) continue;
    const segR = rms(audio, Math.floor(seg.start * SR), Math.floor(seg.end * SR));
    if (segR < SILENCE_RMS * 1.2) continue;
    const prev = out[out.length - 1];
    if (prev && prev.text.toLowerCase() === text.toLowerCase()) continue;
    let start = Math.max(seg.start, prev ? prev.end : 0);
    let end = Math.max(seg.end, start + 0.3);
    const dur = end - start;
    const cps = text.length / dur;
    let flag = null;
    if (collapsed) flag = "Repeated words removed — please check";
    else if (cps > 24) flag = "Very fast text — words may be mis-heard";
    else if (dur > 12) flag = "Long segment — check timing";
    else if (text.length <= 2) flag = "Very short — may be noise";
    out.push({ id: uid(), start: +start.toFixed(3), end: +end.toFixed(3), text, flag, words: syncWords(seg.words, text) });
  }
  return out;
}

function syncWords(words, text) {
  if (!words) return undefined;
  const toks = text.split(/\s+/).filter(Boolean);
  return toks.length === words.length ? words.map((w, i) => ({ ...w, w: toks[i] })) : undefined;
}
